import { a4 as historyRef } from './AccountTreeList-58ce8378.js';

function pathFactory(path, component, protectedRoute) {
    return {
        path: path,
        component: component,
        protectedRoute: protectedRoute
    };
}

var navigate = function (_a) {
    var route = _a.route,
        search = _a.search,
        _b = _a.keepPreviousParams,
        keepPreviousParams = _b === void 0 ? true : _b,
        _c = _a.pushToState,
        pushToState = _c === void 0 ? true : _c;
    var _search = new URLSearchParams(keepPreviousParams ? location.search : '');
    search && Object.keys(search).forEach(function (key) {
        search[key] ? _search.set(key, search[key]) : _search.delete(key);
    });
    var updateFn = pushToState ? historyRef.push : historyRef.replace;
    updateFn.bind(historyRef)((route !== null && route !== void 0 ? route : location.pathname) + "?".concat(_search.toString()));
};

export { navigate as n, pathFactory as p };
